<div *ngIf="items" class="od-block">
  <div class="block-title" i18n="@@dashboard-origins.dashboardTopOrigins">
    Top Origins and Destinations
  </div>
  <table>
    <tr
      *ngFor="let item of items; let i = index"
      class="od-record"
      [@dive]="{
        value: diveState,
        params: {
          distance: '-10px',
          delay: i * 100 + 'ms',
          easing: 'ease'
        }
      }"
    >
      <td class="record-name">{{ item.name }}</td>
      <td class="record-values">
        <ng-container *ngFor="let value of item.values">
          <div class="line-holder">
            <div class="line" [style.width.%]="valuesScale && 0.78 * value"></div>
            <span class="num">{{ compareValue(value) }}</span
            >%
          </div>
        </ng-container>
      </td>
    </tr>
    <tr class="od-legend">
      <td>
        <div class="legend-item-color"></div>
        <span class="legend-item current-item">{{ recordTitle }}</span>
      </td>
      <td>
        <div class="legend-item-color"></div>
        <span class="legend-item all-items">{{ allRecordsTitle }}</span>
      </td>
    </tr>
  </table>
</div>
